import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton,
    Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        backgroundColor: '#000000',
        color: '#ffffff',
    },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        borderColor: 'rgba(255, 255, 255, 0.12)',
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function MaintenanceModal({ open, onClose, title, description }) {
    const [expanded, setExpanded] = useState(false);

    const handleToggleExpand = () => {
        setExpanded(!expanded);
    };

    // Truncate description if too long and not expanded
    // This is a simple logic, can be improved based on requirements
    const shouldTruncate = description && description.length > 150;
    const displayDescription = expanded || !shouldTruncate
        ? description
        : `${description.substring(0, 150)}...`;

    return (
        <BootstrapDialog
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} id="customized-dialog-title">
                {title || "System Schedule Maintenance"}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            color: '#ffffff',
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom sx={{ whiteSpace: 'pre-line' }}>
                    {displayDescription}
                </Typography>
                {shouldTruncate && (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                        <Button size="small" onClick={handleToggleExpand}>
                            {expanded ? "See Less" : "See More"}
                        </Button>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={onClose}>
                    Understood
                </Button>
            </DialogActions>
        </BootstrapDialog>
    );
}

export default MaintenanceModal;
